/* Helper functions for parsing google addresses */
export const addressParser = {

  /**
   * Helper function to parse addresses from google address lookup
   *
   * @param {string} address - address string in format: Address_1(with potential comma), Suburb State, Country
   * @returns {object} - parsed address object with properties: addressFull, streetAddress, suburb, state, postcode, country
   */
  parseAddress: async address => {

    // split address by comma
    const addressArray = address.split(",");

    // remove country from address
    const parsedAddress = {
      addressFull: address.trim(),
      country: addressArray.pop().trim()
    }

    // separate suburb and state
    // extract suburb using regex (space followed by 2 or 3 capital letters at end)
    const suburbState = addressArray.pop()
    const suburbStateMatches = /(.*?) ([A-Z]{2,3})$/.exec(suburbState)

    // last match will be the state
    parsedAddress.state = suburbStateMatches.pop()

    // everything else is the suburb
    parsedAddress.suburb = suburbStateMatches.pop().trim()

    // Re-join the remaining address
    parsedAddress.streetAddress = addressArray.join(",").trim()

    // add postcode
    parsedAddress.postcode = await addressParser.getPostalCode(address)

    return parsedAddress
  },

  addressLookup: async query => {

    try {

      const autoComplete = new window.google.maps.places.AutocompleteService()

      const response = await autoComplete.getPlacePredictions({
        componentRestrictions: {country: "au"},
        input: query,
        types: ["address"],
      })

      return response.predictions

    } catch (error) {
      console.log('Error getting address predictions: ', error)
      return []
    }
  },

  /**
   * Use geocode to get postcode
   * @param address
   * @return {String} postcode
   */
  getPostalCode: address => {
    const geo = new window.google.maps.Geocoder()
    const request = {
      address,
      componentRestrictions: {country: "au"},
    }
    return geo.geocode(request)
      .then((res) => {
        const data = res.results[0].address_components.filter(
          (component) => {
            return component.types[0] === "postal_code"
          }
        );
        return data[0].long_name || ''
      })
      .catch((err) => {
        console.log(err)
        return ''
      })
  }
}